import { Chip, Switch, TableCell, TableRow } from "@mui/material"
import { If } from "lib/@components/switch"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { formatRateCardModifierScope } from "../rate-cards/rate-card-modifier-scope"
import { CostFigure } from "./cost-figure"

export function ModifierRow({ item, currencySymbol, showScope, tradeOptions }) {
    const { onToggleModifier, modifiersUpdating } = useBoundContext()
    const contribution = item.contribution || 0
    return (
        <TableRow data-cy="modifier-row">
            <TableCell>{item.name}</TableCell>
            <If value={showScope}>
                <TableCell data-cy="modifier-scope">{formatRateCardModifierScope(item.scope, tradeOptions)}</TableCell>
            </If>
            <TableCell>
                <Chip
                    size="small"
                    variant={getModifierVariant()}
                    label={getModifierLabel()}
                    color={getModifierColor()}
                    sx={{ height: 22, minWidth: 92 }}
                />
            </TableCell>
            <TableCell align="center">
                <Switch
                    data-cy={`modifier-toggle-${item.id}`}
                    size="small"
                    checked={!item.disabled}
                    disabled={!onToggleModifier || modifiersUpdating}
                    inputProps={{ "aria-label": `${item.name} modifier` }}
                    onChange={handleToggle}
                />
            </TableCell>
            <TableCell align="right">
                <CostFigure value={contribution} currencySymbol={currencySymbol} showPlus />
            </TableCell>
            <TableCell align="right">
                <CostFigure value={item.running} currencySymbol={currencySymbol} />
            </TableCell>
        </TableRow>
    )

    function handleToggle(event) {
        onToggleModifier?.(item.id, event.target.checked)
    }

    function getModifierLabel() {
        if (item.pending) return "Pending"
        if (item.disabled) return "Skipped"
        return formatApplyTo(item)
    }

    function getModifierColor() {
        if (item.pending) return "info"
        if (item.disabled) return "default"
        return "primary"
    }

    function getModifierVariant() {
        if (item.pending) return "filled"
        return "outlined"
    }
}

function formatApplyTo(modifier) {
    if (modifier.type === "fixed") return "Fixed amount"
    if (modifier.applyTo === "base") return "Base cost"
    return "Compound"
}
